import helveticaBoldUrl from '../assets/fonts/7ce0a2f5-eb00-46aa-919c-5b3f3667646c.woff2';

export const LABEL_IMAGE_WIDTH = 1920;
export const LABEL_IMAGE_HEIGHT = 1080;

export const COLORS = [{ bg: '#d7d7d7', fg: '#000000' }, { bg: '#fdf189', fg: '#000000' }, { bg: '#ff5a00', fg: '#ffffff' }];
const ROLAND_LOGO_PATH = [
    new Path2D('M90.93.94V22.52a.93.93,0,0,0,.94.94h2.57a.93.93,0,0,0,.94-.94V.94A.92.92,0,0,0,94.44,0H91.87A.92.92,0,0,0,90.93.94Z'),
    new Path2D('M135.4,22.52V13a6.93,6.93,0,0,0-6.48-6.87,10.55,10.55,0,0,0-6.81,2.15c-.16.13-.6.26-.6-.13v-1a.91.91,0,0,0-.93-.93h-2.22a.92.92,0,0,0-.94.93V22.52a.92.92,0,0,0,.94.94h2.22a.92.92,0,0,0,.93-.94V15a5.6,5.6,0,0,1,6-5.61c3.28,0,3.8,2.26,3.8,3.6v9.51a.91.91,0,0,0,.94.93h2.21A.92.92,0,0,0,135.4,22.52Z'),
    new Path2D('M97.83,11v.1'),
    new Path2D('M147.1,9.5a5.52,5.52,0,0,1,5.79,5.61,5.72,5.72,0,1,1-11.43,0A5.55,5.55,0,0,1,147.1,9.5ZM152.45,22c.27-.21.55,0,.54.46a.94.94,0,0,0,.94,1h2.22a.91.91,0,0,0,.93-.94V.94a.9.9,0,0,0-.93-.93h-2.22a.91.91,0,0,0-.94.93V7.75c0,.5-.27.67-.54.46-6-4.63-15.22,0-15.2,6.85C137.27,22.72,146.32,26.85,152.45,22Z'),
    new Path2D('M102.32,16.77c2.12-1.12,7.34-1,7.82-.95.25,0,.6.21.59.55,0,4.52-6.18,5.13-8.54,3.57a1.86,1.86,0,0,1-.83-1.43A1.75,1.75,0,0,1,102.32,16.77Zm-2.75,6.07c2.9,2.07,8.29,1.57,10.74-.58a.45.45,0,0,1,.74.26c.24.75.59.93,1.34.94h1.53a.91.91,0,0,0,.93-.94V12.81c0-5.28-4.92-6.68-8.7-6.68-4.22,0-7,1.61-8.32,4.87-.14.33.26.73.59.73h2.88a1.59,1.59,0,0,0,1.14-.66c.74-1.26,2-1.72,4.23-1.72,2.51,0,3.17.56,4,1.72a1,1,0,0,1-.58,1.54,61,61,0,0,0-8.73.8,5.15,5.15,0,0,0-1.78,9.42ZM78.86,24.06c7.48,0,10.61-4.85,10.61-9,0-3.93-3.15-9-10.67-9s-10.65,5-10.65,9C68.15,19.29,71.32,24.06,78.86,24.06Zm0-3.21c-4.37,0-6.37-3.24-6.37-5.72a6.35,6.35,0,0,1,12.64,0A6,6,0,0,1,78.86,20.85Zm-28.67-7v8.67a.91.91,0,0,1-.94.93H47.16a.91.91,0,0,1-.95-.93V.93A.92.92,0,0,1,47.15,0h13.6a6.37,6.37,0,0,1,6.59,6.45,6.55,6.55,0,0,1-2.9,5.24c-.14.09-.24.27-.18.32,1.17.92,1.18,1.66,1.59,3.23.73,2.84.82,5.32,1.94,7.7a.42.42,0,0,1-.37.5H64.71a1.45,1.45,0,0,1-1.54-.94c-1-3-.31-5.85-2.33-8.67a3.35,3.35,0,0,0-2.76-.94H51.13A.92.92,0,0,0,50.19,13.84Zm9.24-4.05s3.65,0,3.65-3.34S59.43,3.1,59.43,3.1h-8.3a.92.92,0,0,0-.94.94V8.85a1,1,0,0,0,.94.94Z'),
    new Path2D('M37.09,10.29h-23A5.67,5.67,0,0,0,8.32,16a5.81,5.81,0,0,0,5.8,5.75H42.21v1.7H14.09a7.44,7.44,0,1,1,0-14.87H35.32V6.25H6.53V23.44H4.64V4.53H37.09Z'),
    new Path2D('M12.36,18.93H42.21V17.22H14.12V14.89H35.37a7.35,7.35,0,0,0,7.55-7.43A7.46,7.46,0,0,0,35.26,0H0V23.44H1.89V1.72H35.32a5.83,5.83,0,0,1,5.82,5.76,5.68,5.68,0,0,1-5.82,5.69h-23Z')
];

const LABEL_FONT_FAMILY = 'Helvetica LT W01 Bold';
const LABEL_FONT = new FontFace(LABEL_FONT_FAMILY, `url(${helveticaBoldUrl})`);
LABEL_FONT.load().then(f => document.fonts.add(f));

export function drawLabel(ctx: CanvasRenderingContext2D, artistName: string, trackName: string, backgroundColor: string, foregroundColor: string) {
    // Image background
    ctx.fillStyle = 'black';
    ctx.fillRect(0, 0, LABEL_IMAGE_WIDTH, LABEL_IMAGE_HEIGHT);

    // Label background
    ctx.fillStyle = backgroundColor;
    ctx.beginPath();
    ctx.arc(LABEL_IMAGE_WIDTH / 2, LABEL_IMAGE_HEIGHT / 2, 350, 0, Math.PI * 2);
    ctx.fill();

    // Center hole
    ctx.fillStyle = 'black';
    ctx.beginPath();
    ctx.arc(LABEL_IMAGE_WIDTH / 2, LABEL_IMAGE_HEIGHT / 2, 26, 0, Math.PI * 2);
    ctx.fill();

    // Roland logo
    ctx.fillStyle = foregroundColor;
    ctx.save();
    ctx.translate(LABEL_IMAGE_WIDTH / 2 - 200, LABEL_IMAGE_HEIGHT / 2 - 230);
    ctx.scale(2.5, 2.5);
    for (let p of ROLAND_LOGO_PATH) {
        ctx.fill(p);
    }
    ctx.restore();

    // Artist name
    ctx.font = `40px "${LABEL_FONT_FAMILY}"`;
    let artistWidth = ctx.measureText(artistName).width;
    ctx.fillText(
        artistName,
        LABEL_IMAGE_WIDTH / 2 - artistWidth / 2,
        LABEL_IMAGE_HEIGHT / 2 - 80
    );

    // Track name
    ctx.font = `40px "${LABEL_FONT_FAMILY}"`;
    let trackWidth = ctx.measureText(trackName).width;
    ctx.fillText(
        trackName,
        LABEL_IMAGE_WIDTH / 2 - trackWidth / 2,
        LABEL_IMAGE_HEIGHT / 2 + 160
    );

    // Small print
    ctx.font = `20px "${LABEL_FONT_FAMILY}"`;
    ctx.fillText('SIDE A', LABEL_IMAGE_WIDTH / 2 + 80, LABEL_IMAGE_HEIGHT / 2 + 8);
    ctx.fillText('33.3 RPM', LABEL_IMAGE_WIDTH / 2 - 180, LABEL_IMAGE_HEIGHT / 2 + 8);
    ctx.fillText('' + new Date().getFullYear(), LABEL_IMAGE_WIDTH / 2 - 180, LABEL_IMAGE_HEIGHT / 2 + 28);
}